var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#537983"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E5959"
    },
    d: "M372.504,147.24l-4.664,4.664l-84.669-84.669L239.75,81.5l26.654,45.331L90.581,302.654   l95.384,95.384l-19.788,19.788l94.12,94.12c129.604-2.135,235.765-100.57,250.049-226.864L372.504,147.24z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDBF00"
    },
    d: "M261,58.183c-17.49,0-31.608,14.118-31.608,31.608c0,17.489,14.118,31.608,31.608,31.608    s31.608-14.119,31.608-31.608C292.608,72.301,278.49,58.183,261,58.183z M261,100.328c-5.901,0-10.536-4.637-10.536-10.536    c0-5.901,4.635-10.536,10.536-10.536c5.901,0,10.536,4.635,10.536,10.536C271.536,95.691,266.901,100.328,261,100.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9100"
    },
    d: "M292.608,89.791c0,17.489-14.118,31.608-31.608,31.608v-21.072c5.901,0,10.536-4.637,10.536-10.536    c0-5.901-4.635-10.536-10.536-10.536V58.183C278.49,58.183,292.608,72.301,292.608,89.791z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA2D"
    },
    d: "M419.745,259.072v31.608H102.255v-31.608c0-87.24,71.505-158.745,158.745-158.745    c43.62,0,83.025,18.402,111.683,47.062C401.341,176.047,419.745,215.452,419.745,259.072z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDBF00"
    },
    d: "M419.745,259.072v31.608H261V100.328c43.62,0,83.025,18.402,111.683,47.062    C401.341,176.047,419.745,215.452,419.745,259.072z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDBF00"
    },
    d: "M440.817,269.608v10.536c0,17.489-14.118,31.608-31.608,31.608H112.791    c-17.49,0-31.608-14.119-31.608-31.608v-10.536H440.817z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9100"
    },
    d: "M440.817,269.608v10.536c0,17.489-14.118,31.608-31.608,31.608H261v-42.145H440.817z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBDCFF"
    },
    points: "278.911,399.905 179.872,399.905 229.392,350.174   "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9ABADB"
    },
    points: "229.392,350.174 278.911,399.905 229.392,399.905   "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.855,
    y: 322.289,
    style: {
      fill: "#BBDCFF"
    },
    width: 21.072,
    height: 42.847
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.392,
    y: 322.289,
    style: {
      fill: "#9ABADB"
    },
    width: 10.536,
    height: 42.847
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0F4FF"
    },
    points: "300.194,227.464 278.911,248.536 187.247,248.536 158.589,227.464 167.65,164.247     291.133,164.247   "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBDCFF"
    },
    points: "278.911,248.536 229.392,248.536 229.392,164.247 291.133,164.247 300.194,227.464   "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF641A"
    },
    d: "M230.234,332.825h-1.685c-44.884,0-79.443-39.827-73.122-84.289l3.161-21.072h141.605l3.161,21.072    C309.677,292.998,275.118,332.825,230.234,332.825z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F03800"
    },
    d: "M230.234,332.825h-0.842V227.464h70.803l3.161,21.072    C309.677,292.998,275.118,332.825,230.234,332.825z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.175,
    y: 396.745,
    style: {
      fill: "#E0F4FF"
    },
    width: 126.434,
    height: 21.072
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.392,
    y: 396.745,
    style: {
      fill: "#BBDCFF"
    },
    width: 63.217,
    height: 21.072
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinner);
export default __webpack_public_path__ + "static/media/dinner.318990530b41f24d32b919efe4bd7fd6.svg";
export { ForwardRef as ReactComponent };